import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import styled from "styled-components";
import { getAnyProfileDetails } from "./utilities/ApiCalls";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Scrollbars } from "react-custom-scrollbars";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useModel } from "../hooks/modelcontex";
import { useTranslation } from "react-i18next";
import ProfileImage from "../Componets/ProfileImage";
const FollowerFollowingList = () => {
  const [t] = useTranslation();
  const [profile, setProfile] = useState();
  const { Option, setFollowOptions } = useModel();
  const { userId } = useParams();

  const getProxiedImageUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    if (
      url.includes("data:image") ||
      url.includes("blob:") ||
      url.startsWith("static/") ||
      url.startsWith("/static") ||
      url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com")
    )
      return url;
    return `https://api.storytent.in/api/proxy-image?url=${encodeURIComponent(
      url
    )}`;
  };

  useEffect(() => {
    getAnyProfileDetails(userId).then((response) => {
      setProfile(response.data.data);
    });
  }, [userId]);

  return (
    <Layout>
      <GridBackground>
        <Container>
          <Tab>
            <TabButton
              active={Option === "followers"}
              onClick={() => setFollowOptions("followers")}
            >
              {t("Profile.Followers")}
            </TabButton>
            <TabButton
              active={Option === "following"}
              onClick={() => setFollowOptions("following")}
            >
              {t("Profile.Following")}
            </TabButton>
          </Tab>

          <Content>
            <Scrollbars style={{ width: "100%", height: "100%" }} autoHide>
              <ListWrapper>
                {Option === "followers"
                  ? profile?.followersList.map((data, idx) => (
                      <ProfileCard
                        key={idx}
                        to={`/userprofile/${data.followerId}`}
                      >
                        <ProfileImage
                          src={data?.profilePic}
                          name={data?.name}
                          size={48}
                          alt="img"
                          proxiedUrl={getProxiedImageUrl}
                        />
                        <UserName>{data.name}</UserName>
                      </ProfileCard>
                    ))
                  : profile?.followingList?.map((data, idx) => (
                      <ProfileCard
                        key={idx}
                        to={`/userprofile/${data.followingId}`}
                      >
                        <ProfileImage
                          src={data?.profilePic}
                          name={data?.name}
                          size={48}
                          alt="img"
                          proxiedUrl={getProxiedImageUrl}
                        />
                        <UserName>{data.name}</UserName>
                      </ProfileCard>
                    ))}
              </ListWrapper>
            </Scrollbars>
          </Content>
        </Container>
      </GridBackground>
    </Layout>
  );
};

export default FollowerFollowingList;

const GridBackground = styled.div`
  width: 100%;
  height: 100vh;
  background-color: var(--color-background);
  background-image: linear-gradient(var(--color-border) 1px, transparent 1px);
  background-size: 100% 25px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 30px;
`;

const Container = styled.div`
  width: 100%;
  max-width: 500px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
`;

const Tab = styled.div`
  width: 100%;
  display: flex;
  background-color: #ffffff;
  border: 1px solid var(--color-border);
  [data-theme="dark"] & {
    background-color: var(--color-surface);
    border-color: var(--color-border);
  }
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 100px;
  height: 56px;
  padding: 4px;
  margin-bottom: 24px;
`;

const TabButton = styled.button`
  flex: 1;
  background-color: ${(props) =>
    props.active ? "var(--color-primary)" : "transparent"};
  color: ${(props) => (props.active ? "#FFFFFF" : "var(--color-primary)")};
  [data-theme="dark"] & {
    background-color: ${(props) => (props.active ? "#FFFFFF" : "transparent")};
    color: ${(props) => (props.active ? "#000000" : "var(--color-text)")};
  }
  height: 100%;
  border-radius: 100px;
  outline: none;
  border: none;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) =>
      props.active ? "var(--color-primary)" : "rgba(0,0,0,0.05)"};
  }
`;

const Content = styled.div`
  width: 100%;
  flex: 1;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 24px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 12px;
`;

const ProfileCard = styled(Link)`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border-radius: 16px;
  background-color: var(--color-background);
  border: 1px solid var(--color-border);
  text-decoration: none;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: var(--color-primary);
  }
`;

const UserName = styled.h2`
  color: var(--color-text);
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;
